import React, { useMemo, useState } from 'react';
import { Card, CardContent } from '../components/ui/card';
import QLanguageContentPage from './QLanguageContentPage';
import QLanguageTextbookMediaPage from './QLanguageTextbookMediaPage';

type CmsSurface = {
  id: string;
  applicationKey: string;
  applicationLabel: string;
  contentTypeKey: string;
  contentTypeLabel: string;
  render: () => React.ReactNode;
};

const CMS_SURFACES: readonly CmsSurface[] = [
  {
    id: 'q-language:mission',
    applicationKey: 'q-language',
    applicationLabel: 'Q 언어',
    contentTypeKey: 'mission',
    contentTypeLabel: '학습 미션',
    render: () => <QLanguageContentPage embedded />,
  },
  {
    id: 'q-language:textbook-media',
    applicationKey: 'q-language',
    applicationLabel: 'Q 언어',
    contentTypeKey: 'textbook-media',
    contentTypeLabel: '교재 영상',
    render: () => <QLanguageTextbookMediaPage embedded />,
  },
];

export default function ContentManagementPage() {
  const [applicationKey, setApplicationKey] = useState(CMS_SURFACES[0].applicationKey);
  const availableSurfaces = useMemo(
    () => CMS_SURFACES.filter((surface) => surface.applicationKey === applicationKey),
    [applicationKey],
  );
  const [contentTypeKey, setContentTypeKey] = useState(CMS_SURFACES[0].contentTypeKey);
  const selectedSurface = availableSurfaces.find((surface) => surface.contentTypeKey === contentTypeKey)
    ?? availableSurfaces[0];

  const selectApplication = (nextApplicationKey: string) => {
    const firstSurface = CMS_SURFACES.find((surface) => surface.applicationKey === nextApplicationKey);
    if (!firstSurface) return;
    setApplicationKey(nextApplicationKey);
    setContentTypeKey(firstSurface.contentTypeKey);
  };

  return (
    <div className="grid min-w-0 gap-5">
      <Card>
        <CardContent className="flex flex-wrap items-end gap-4 p-4">
          <div className="mr-auto min-w-64">
            <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">범용 CMS</p>
            <h1 className="mt-1 text-xl font-bold">콘텐츠 관리</h1>
            <p className="mt-1 text-sm text-muted-foreground">제품과 콘텐츠 유형을 선택해 같은 발행·검증·버전 관리 흐름으로 운영합니다.</p>
          </div>
          <label className="grid min-w-40 gap-1 text-xs font-medium text-muted-foreground">
            제품
            <select
              aria-label="CMS 제품"
              className="h-9 rounded-md border bg-background px-3 text-sm text-foreground"
              value={applicationKey}
              onChange={(event) => selectApplication(event.target.value)}
            >
              {[...new Map(CMS_SURFACES.map((surface) => [surface.applicationKey, surface])).values()].map((surface) => (
                <option key={surface.applicationKey} value={surface.applicationKey}>{surface.applicationLabel}</option>
              ))}
            </select>
          </label>
          <label className="grid min-w-40 gap-1 text-xs font-medium text-muted-foreground">
            콘텐츠 유형
            <select
              aria-label="CMS 콘텐츠 유형"
              className="h-9 rounded-md border bg-background px-3 text-sm text-foreground"
              value={selectedSurface?.contentTypeKey ?? ''}
              onChange={(event) => setContentTypeKey(event.target.value)}
            >
              {availableSurfaces.map((surface) => (
                <option key={surface.id} value={surface.contentTypeKey}>{surface.contentTypeLabel}</option>
              ))}
            </select>
          </label>
        </CardContent>
      </Card>
      {selectedSurface?.render()}
    </div>
  );
}
